import { render, staticRenderFns } from "./richPop.vue?vue&type=template&id=058e72bc&scoped=true"
import script from "./richPop.vue?vue&type=script&lang=js"
export * from "./richPop.vue?vue&type=script&lang=js"
import style0 from "@wangeditor/editor/dist/css/style.css?vue&type=style&index=0&lang=css&external"
import style1 from "./richPop.vue?vue&type=style&index=1&id=058e72bc&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "058e72bc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('058e72bc')) {
      api.createRecord('058e72bc', component.options)
    } else {
      api.reload('058e72bc', component.options)
    }
    module.hot.accept("./richPop.vue?vue&type=template&id=058e72bc&scoped=true", function () {
      api.rerender('058e72bc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/operationManagement/customPage/components/richPop.vue"
export default component.exports